import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const KashmirPage = () => {
  return <DestinationTemplate destinationId="kashmir" />;
};

export default KashmirPage;
